import { useCallback, useEffect, useMemo, useState, type RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useEventListener } from '@shared/hooks';

const INITIAL_STATE = { shift: 0, scale: 0, ready: false };

interface UseIndicatorPositionProps {
  index: number;
  ref: RefObject<HTMLElement>;
}

export const useIndicatorPosition = (props: UseIndicatorPositionProps) => {
  const [result, setResult] = useState(INITIAL_STATE);

  const { i18n } = useTranslation();

  const realign = useCallback(
    (index: number) => {
      if (!props.ref.current) return;
      const items = props.ref.current.querySelectorAll('li');
      if (!items[index]) return;
      const parent = props.ref.current.getBoundingClientRect();
      const rect = items[index].getBoundingClientRect();

      const shift = rect.left - parent.left;
      const scale = rect.width / parent.width;
      setResult({ shift, scale, ready: true });
    },
    [props.ref],
  );

  useEffect(() => {
    realign(props.index);
  }, [props.index, realign, i18n.language]);
  useEventListener('resize', () => realign(props.index));

  return useMemo(() => result, [result]);
};
